import ReactDOM from 'react-dom/client';

import { Provider } from 'react-redux'
import { store } from './app/store';
//
import App from './App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';


// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
    <Provider store={store}>
        <App />
    </Provider>
);
serviceWorker.unregister();

reportWebVitals();
